import script from "./TranslationTextGame.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslationTextGame.vue?vue&type=script&setup=true&lang=js"

import "./TranslationTextGame.vue?vue&type=style&index=0&id=63a2441c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a2441c"]])

export default __exports__